import BtnSwitch from "../Button/BtnSwitch";
import stylesSwitch from "../Button/BtnSwitch.module.css";
import styles from "./ReactTableBase.module.css";
import React from "react";

const RenderCellBool = ({ value, row, column, putActifSwitch= null, enableLabel = "Vrai", disableLabel = "Faux" }) => {
    if (putActifSwitch === null) return value ? enableLabel : disableLabel;
    return <BtnSwitch
        active={value}
        onToggle={(e) => putActifSwitch({
            value: !value,
            row: row,
            target: column.id
        })}
        activeLabel={enableLabel}
        inactiveLabel={disableLabel}
        classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}
    />;
}


export default RenderCellBool;